export const portfolioStateOfNatureQuery = `
  query PortfolioStateOfNature(
    $businessCentralId: String!
    $isic: [String!]!
    $countries: [String!]!
    $physicalRiskLevels: [GqlRiskBandLevel!]!
    $dependencyLevels: [GqlRiskBandLevel!]!
    $impactLevels: [GqlRiskBandLevel!]!
    $sonLevels: [GqlSonBandLevel!]!
    $at: DateTime
  ) {
    organisation(businessCentralId: $businessCentralId, at: $at) {
      portfolioRiskStats(
        isic: $isic
        countries: $countries
        physicalRiskLevels: $physicalRiskLevels
        dependencyLevels: $dependencyLevels
        impactLevels: $impactLevels
        sonLevels: $sonLevels
      ) {
        assessedSiteCount
        meanStateOfNature
        sonCategoryBreakdown {
          sourceKey
          name
          score
          band
          factors {
            sourceKey
            name
            score
            band
            weight
          }
        }
      }
    }
  }
`;

export type GqlSonPortfolioFactor = {
    sourceKey: string;
    name: string;
    score: number | null;
    band: 'VERY_GOOD' | 'GOOD' | 'MODERATE' | 'POOR' | 'VERY_POOR';
    weight: number;
};

export type GqlSonCategoryScore = {
    sourceKey: string;
    name: string;
    score: number | null;
    band: 'VERY_GOOD' | 'GOOD' | 'MODERATE' | 'POOR' | 'VERY_POOR' | null;
    factors: GqlSonPortfolioFactor[];
};

export type PortfolioStateOfNatureResult = {
    organisation: {
        portfolioRiskStats: {
            assessedSiteCount: number;
            meanStateOfNature: number | null;
            sonCategoryBreakdown: GqlSonCategoryScore[];
        };
    } | null;
};
